import { DefaultInputPropTypes, SearchInput } from 'framework/form';
import usePositionSlotsService from '../usePositionSlotsService';
import { PositionSlotListItem } from '../types';
import { buildPositionSlotSummaryLine } from '../utils/positionSlotDisplay';
import { PositionType, usePositionService } from 'domain/shared/employee';
import { LoadingParams } from 'framework/list';
import { POSITION_SLOT_STATUS } from '../constants';
import { useTechnologyService } from 'domain/shared/career';

const PositionSlotInput = (props: DefaultInputPropTypes<number[]>) => {
  const { findAll: findAllPositions } = usePositionService();
  const { findAll: findAllTechnologies } = useTechnologyService();
  const { getPositionSlotsPage } = usePositionSlotsService();

  const searchOpenPositionSlotsForInput = async (params: LoadingParams) => {
    const searchString = params.filter?.searchString?.ct || '';
    const normalizedSearchString = searchString.trim().toLowerCase();
    const matchingSpecializationIds: number[] = normalizedSearchString
      ? (await findAllPositions())
          .filter((position: PositionType) => position.name.toLowerCase().includes(normalizedSearchString))
          .map((position: PositionType) => position.id)
      : [];

    const matchingTechnologyIds =
      normalizedSearchString && matchingSpecializationIds.length === 0
        ? (await findAllTechnologies())
            .filter(technology => technology.name.toLowerCase().includes(normalizedSearchString))
            .map(technology => technology.id)
        : [];

    if (normalizedSearchString && matchingSpecializationIds.length === 0 && matchingTechnologyIds.length === 0) {
      return { result: [], pageNumber: params.pageNumber, totalPages: 1, totalElements: 0 };
    }

    const response = await getPositionSlotsPage({
      ...params,
      filter: {
        status: {
          eq: POSITION_SLOT_STATUS.OPEN,
        },
        vacancyId: {
          NULL: true,
        },
        ...(matchingSpecializationIds.length > 0
          ? {
              specializationId: {
                in: matchingSpecializationIds.map(item => String(item)),
              },
            }
          : matchingTechnologyIds.length > 0
            ? { technologyId: { in: matchingTechnologyIds } }
            : {}),
      },
    });

    return response;
  };

  return (
    <SearchInput
      placeholder="Select position slot"
      minSearchLength={0}
      isInfinityLoading
      searchRequest={searchOpenPositionSlotsForInput}
      mapResults={(positionSlot: PositionSlotListItem) => ({
        id: positionSlot.id,
        text: buildPositionSlotSummaryLine(positionSlot),
      })}
      noResultMessage="No open position slots found."
      {...props}
    />
  );
};

export default PositionSlotInput;
